module.exports = __webpack_public_path__ + "img/751ff1d.png";